import getConfig from 'next/config';

import { Http, Query } from '@catawiki/runtime-toolkit';

const { publicRuntimeConfig } = getConfig();

export const queryClient = Query.createClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        if (
          process.env.NODE_ENV === 'test' ||
          publicRuntimeConfig.stage === 'test' ||
          Http.isResponseErrorOfStatus(error, Http.NOT_FOUND)
        ) {
          return false;
        }
        return count < 3;
      },
    },
  },
});

export const queryClientTest = Query.createClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: Infinity,
    },
  },
});
